import PropTypes from 'prop-types'

import SelectBox from 'components/form/SelectBox'

const DEFAULT_SIZES = [10, 20, 50, 100, 200]

const PageSize = ({
  size,
  onSizeChange,
  disabled,
  values = DEFAULT_SIZES,
  unit = '행',
}) => (
  <div className="single_wrap">
    <SelectBox
      className="opt_row"
      value={size}
      onValueChange={onSizeChange}
      noBlurOnDefault
      disabled={disabled}>
      {values.map(v => (
        <SelectBox.Item
          key={v}
          text={`${unit} : ${v}`}
          value={v}>{`${v}개`}</SelectBox.Item>
      ))}
    </SelectBox>
  </div>
)

export default PageSize

PageSize.propTypes = {
  onSizeChange: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.number),
  unit: PropTypes.string,
}
